import { useState } from 'react'
import { useApiQuery } from 'grabbitbot-legacy-ui'
import { screenerClient } from '../../api'

/** Equivalent of legacy `AdminUserUsageStatComponent` (audit §3/§4 —
 * per-user hourly usage, `GET /admin/statistics/user/usage/hourly?email`). */
export function AdminUserUsagePage() {
  const [email, setEmail] = useState('')
  const [submittedEmail, setSubmittedEmail] = useState('')
  const { data, loading, error } = useApiQuery(
    () => (submittedEmail ? screenerClient.admin.userHourlyUsage(submittedEmail) : Promise.resolve(null)),
    [submittedEmail],
  )

  return (
    <div>
      <h1>Admin — per-user usage</h1>
      <form
        className="screener-form"
        onSubmit={(e) => {
          e.preventDefault()
          setSubmittedEmail(email)
        }}
      >
        <label>
          User email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <button type="submit">Search</button>
      </form>
      {loading && <p>Loading…</p>}
      {error && <p role="alert">Could not load usage statistics.</p>}
      {data != null && <pre>{JSON.stringify(data, null, 2)}</pre>}
    </div>
  )
}
